import React from 'react';
import Headline from '../../partials/Headline';
import photo_1 from '../../assets/images/provozovna/provozovna (1).png';
import photo_2 from '../../assets/images/provozovna/provozovna (2).png';
import photo_3 from '../../assets/images/provozovna/provozovna (3).png';
import photo_4 from '../../assets/images/provozovna/provozovna (4).png';
import photo_5 from '../../assets/images/provozovna/provozovna (5).png';
import photo_6 from '../../assets/images/provozovna/provozovna (6).png';

const HomepageGallery = () => {
  return (
    <div className="row homepage-gallery">
      <div className="container">
        <Headline h={3} className="headline-gallery">
          Jak to u nás vypadá
        </Headline>
        <div className="row">
          <div className="col">
            <div className="photo-wrap">
              <img src={photo_1} alt="interier" className="photo" />
            </div>
          </div>
          <div className="col">
            <div className="photo-wrap">
              <img src={photo_2} alt="interier" className="photo" />
            </div>
          </div>
          <div className="col">
            <div className="photo-wrap">
              <img src={photo_3} alt="interier" className="photo" />
            </div>
          </div>
          <div className="col">
            <div className="photo-wrap">
              <img src={photo_4} alt="interier" className="photo" />
            </div>
          </div>
          <div className="col">
            <div className="photo-wrap">
              <img src={photo_5} alt="interier" className="photo" />
            </div>
          </div>
          <div className="col">
            <div className="photo-wrap">
              <img src={photo_6} alt="interier" className="photo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomepageGallery;